// extracted by mini-css-extract-plugin
export default {"hrow":"hrow_O2P+A","row":"row_O2P+A","cell":"cell_O2P+A"};